import { Typography } from "@mui/material";
import React, { FC } from "react";
import { Link as RouterLink, LinkProps } from "react-router-dom";
import styled from "styled-components";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";

interface SeeAllTitleProps {
  title: string;
}

interface CompoundComponent {
  Link: FC<LinkProps>;
}

const SeeAllTitle: FC<SeeAllTitleProps> & CompoundComponent = ({
  title,
  children,
}) => {
  return (
    <Title>
      {title}
      {children}
    </Title>
  );
};

SeeAllTitle.Link = (props) => (
  <Link {...props}>
    See All
    <ArrowRightIcon />
  </Link>
);

SeeAllTitle.Link.displayName = "SeeAllTitleLink";

export default SeeAllTitle;

const Title = styled(Typography)`
  justify-content: space-between;
  display: flex;
  font-size: 1.2rem;
  font-weight: 800;
  color: var(--text-color-secondary);
`;

const Link = styled(RouterLink)`
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  font-weight: 700;
  text-decoration: none;
  color: var(--text-color-secondary);
  &:hover {
    color: var(--hover-text-color);
  }
`;
